import { Route } from "@angular/router";

export const StateOfAssetsPaths = {
  Overview: "overzicht",
  OnHold: "onhold",
  Add: "toevoegen",
  Edit: (id: number | string) => `bewerken/${id}`,
  OrganizationInfo: "organisatie",
  BtwNumber: "ondernemingsnummer",
  Rules: "waarderingsregels",
  RealEstate: "onroerende-goederen",
  Machines: "machines",
  RollingStock: "rollende-materieel",
  Goods: "roerende-goederen",
  Stock: "voorraden",
  OutstandingClaims: "vorderingen",
  Investments: "geldbelegingen",
  Liquidity: "liquiditeiten",
  OtherAssets: "andere-activa",
  FinancialDebts: "schulden",
  SupplierDebts: "schulden-leveranciers",
  MemberDebts: "schulden-leden",
  SalaryDebts: "fiscale-schulden",
  OtherDebts: "andere-schulden",
  Subsidies: "subsidies",
  Gifts: "schenkingen",
  OtherRights: "andere-rechten",
  Mortgages: "hypotheken",
  Deposits: "gegeven-waarborgen",
  OtherCommitments: "andere-verbintenissen",
};

export default [
  {
    path: StateOfAssetsPaths.Overview,
    loadComponent: () =>
      import(
        "./pages/staat-van-vermogen/staat-van-vermogen-list/staat-van-vermogen-list.component"
      ).then((c) => c.StaatVanVermogenListComponent),
    data: {
      breadcrumb: "Overzicht",
      title: "Staat van het Vermogen",
      subscriptionTypes: [1, 4],
    },
  },
  {
    path: "",
    redirectTo: StateOfAssetsPaths.Overview,
    pathMatch: "full",
  },
  {
    path: StateOfAssetsPaths.Add,
    loadComponent: () =>
      import(
        "./pages/staat-van-vermogen/staat-van-vermogen-edit/staat-van-vermogen-edit.component"
      ).then((c) => c.StaatVanVermogenEditComponent),
    data: {
      breadcrumb: "Toevoegen",
      title: "Staat van het Vermogen",
      subscriptionTypes: [1, 4],
    },
  },
  {
    path: StateOfAssetsPaths.Edit(":id"),
    loadComponent: () =>
      import(
        "./pages/staat-van-vermogen/staat-van-vermogen-edit/staat-van-vermogen-edit.component"
      ).then((c) => c.StaatVanVermogenEditComponent),
    data: {
      breadcrumb: "Bewerken",
      title: "Staat van het Vermogen",
      subscriptionTypes: [1, 4],
    },
  },
  {
    path: StateOfAssetsPaths.OrganizationInfo,
    loadComponent: () =>
      import(
        "./pages/staat-van-vermogen/state-of-assets-question/state-of-assets-question.component"
      ).then((c) => c.StateOfAssetsQuestionComponent),
    data: {
      breadcrumb: "Officiële adres van de VZW",
      title: "Staat van het Vermogen",
      questionId: 86,
      subscriptionTypes: [1, 4],
    },
  },
  {
    path: StateOfAssetsPaths.BtwNumber,
    loadComponent: () =>
      import(
        "./pages/staat-van-vermogen/state-of-assets-question/state-of-assets-question.component"
      ).then((c) => c.StateOfAssetsQuestionComponent),
    data: {
      breadcrumb: "Ondernemingsnummer van de VZW",
      title: "Staat van het Vermogen",
      questionId: 87,
      subscriptionTypes: [1, 4],
    },
  },
  {
    path: StateOfAssetsPaths.Rules,
    loadComponent: () =>
      import(
        "./pages/staat-van-vermogen/state-of-assets-question/state-of-assets-question.component"
      ).then((c) => c.StateOfAssetsQuestionComponent),
    data: {
      breadcrumb: "Waarderingsregels",
      title: "Staat van het Vermogen",
      questionId: 66,
      subscriptionTypes: [1, 4],
    },
  },
  {
    path: StateOfAssetsPaths.RealEstate,
    loadComponent: () =>
      import(
        "./pages/staat-van-vermogen/state-of-assets-question/state-of-assets-question.component"
      ).then((c) => c.StateOfAssetsQuestionComponent),
    data: {
      breadcrumb: "Onroerende goederen",
      title: "Staat van het Vermogen",
      questionId: 67,
      subscriptionTypes: [1, 4],
    },
  },
  {
    path: StateOfAssetsPaths.Machines,
    loadComponent: () =>
      import(
        "./pages/staat-van-vermogen/state-of-assets-question/state-of-assets-question.component"
      ).then((c) => c.StateOfAssetsQuestionComponent),
    data: {
      breadcrumb: "Machines",
      title: "Staat van het Vermogen",
      questionId: 68,
      subscriptionTypes: [1, 4],
    },
  },
  {
    path: StateOfAssetsPaths.RollingStock,
    loadComponent: () =>
      import(
        "./pages/staat-van-vermogen/state-of-assets-question/state-of-assets-question.component"
      ).then((c) => c.StateOfAssetsQuestionComponent),
    data: {
      breadcrumb: "Rollend materieel",
      title: "Staat van het Vermogen",
      questionId: 69,
      subscriptionTypes: [1, 4],
    },
  },
  {
    path: StateOfAssetsPaths.Goods,
    loadComponent: () =>
      import(
        "./pages/staat-van-vermogen/state-of-assets-question/state-of-assets-question.component"
      ).then((c) => c.StateOfAssetsQuestionComponent),
    data: {
      breadcrumb: "Roerende goederen",
      title: "Staat van het Vermogen",
      questionId: 69,
      subquestion: 2,
      subscriptionTypes: [1, 4],
    },
  },
  {
    path: StateOfAssetsPaths.Stock,
    loadComponent: () =>
      import(
        "./pages/staat-van-vermogen/state-of-assets-question/state-of-assets-question.component"
      ).then((c) => c.StateOfAssetsQuestionComponent),
    data: {
      breadcrumb: "Voorraden",
      title: "Staat van het Vermogen",
      questionId: 70,
      subscriptionTypes: [1, 4],
    },
  },
  {
    path: StateOfAssetsPaths.OutstandingClaims,
    loadComponent: () =>
      import(
        "./pages/staat-van-vermogen/state-of-assets-question/state-of-assets-question.component"
      ).then((c) => c.StateOfAssetsQuestionComponent),
    data: {
      breadcrumb: "Vorderingen",
      title: "Staat van het Vermogen",
      questionId: 71,
      subscriptionTypes: [1, 4],
    },
  },
  {
    path: StateOfAssetsPaths.Investments,
    loadComponent: () =>
      import(
        "./pages/staat-van-vermogen/state-of-assets-question/state-of-assets-question.component"
      ).then((c) => c.StateOfAssetsQuestionComponent),
    data: {
      breadcrumb: "Geldbeleggingen",
      title: "Staat van het Vermogen",
      questionId: 72,
      subscriptionTypes: [1, 4],
    },
  },
  {
    path: StateOfAssetsPaths.Liquidity,
    loadComponent: () =>
      import(
        "./pages/staat-van-vermogen/state-of-assets-question/state-of-assets-question.component"
      ).then((c) => c.StateOfAssetsQuestionComponent),
    data: {
      breadcrumb: "Liquiditeiten",
      title: "Staat van het Vermogen",
      questionId: 73,
      subscriptionTypes: [1, 4],
    },
  },
  {
    path: StateOfAssetsPaths.OtherAssets,
    loadComponent: () =>
      import(
        "./pages/staat-van-vermogen/state-of-assets-question/state-of-assets-question.component"
      ).then((c) => c.StateOfAssetsQuestionComponent),
    data: {
      breadcrumb: "Andere activa",
      title: "Staat van het Vermogen",
      questionId: 74,
      subscriptionTypes: [1, 4],
    },
  },
  {
    path: StateOfAssetsPaths.FinancialDebts,
    loadComponent: () =>
      import(
        "./pages/staat-van-vermogen/state-of-assets-question/state-of-assets-question.component"
      ).then((c) => c.StateOfAssetsQuestionComponent),
    data: {
      breadcrumb: "Financiële schulden",
      title: "Staat van het Vermogen",
      questionId: 75,
      subscriptionTypes: [1, 4],
    },
  },
  {
    path: StateOfAssetsPaths.SupplierDebts,
    loadComponent: () =>
      import(
        "./pages/staat-van-vermogen/state-of-assets-question/state-of-assets-question.component"
      ).then((c) => c.StateOfAssetsQuestionComponent),
    data: {
      breadcrumb: "Schulden t.a.v. leveranciers",
      title: "Staat van het Vermogen",
      questionId: 76,
      subscriptionTypes: [1, 4],
    },
  },
  {
    path: StateOfAssetsPaths.MemberDebts,
    loadComponent: () =>
      import(
        "./pages/staat-van-vermogen/state-of-assets-question/state-of-assets-question.component"
      ).then((c) => c.StateOfAssetsQuestionComponent),
    data: {
      breadcrumb: "Schulden t.a.v. leden",
      title: "Staat van het Vermogen",
      questionId: 77,
      subscriptionTypes: [1, 4],
    },
  },
  {
    path: StateOfAssetsPaths.SalaryDebts,
    loadComponent: () =>
      import(
        "./pages/staat-van-vermogen/state-of-assets-question/state-of-assets-question.component"
      ).then((c) => c.StateOfAssetsQuestionComponent),
    data: {
      breadcrumb: "Fiscale, salariële of sociale schulden",
      title: "Staat van het Vermogen",
      questionId: 78,
      subscriptionTypes: [1, 4],
    },
  },
  {
    path: StateOfAssetsPaths.OtherDebts,
    loadComponent: () =>
      import(
        "./pages/staat-van-vermogen/state-of-assets-question/state-of-assets-question.component"
      ).then((c) => c.StateOfAssetsQuestionComponent),
    data: {
      breadcrumb: "Andere schulden",
      title: "Staat van het Vermogen",
      questionId: 79,
      subscriptionTypes: [1, 4],
    },
  },
  {
    path: StateOfAssetsPaths.Subsidies,
    loadComponent: () =>
      import(
        "./pages/staat-van-vermogen/state-of-assets-question/state-of-assets-question.component"
      ).then((c) => c.StateOfAssetsQuestionComponent),
    data: {
      breadcrumb: "Beloofde subsidies",
      title: "Staat van het Vermogen",
      questionId: 80,
      subscriptionTypes: [1, 4],
    },
  },
  {
    path: StateOfAssetsPaths.Gifts,
    loadComponent: () =>
      import(
        "./pages/staat-van-vermogen/state-of-assets-question/state-of-assets-question.component"
      ).then((c) => c.StateOfAssetsQuestionComponent),
    data: {
      breadcrumb: "Beloofde schenkingen",
      title: "Staat van het Vermogen",
      questionId: 81,
      subscriptionTypes: [1, 4],
    },
  },
  {
    path: StateOfAssetsPaths.OtherRights,
    loadComponent: () =>
      import(
        "./pages/staat-van-vermogen/state-of-assets-question/state-of-assets-question.component"
      ).then((c) => c.StateOfAssetsQuestionComponent),
    data: {
      breadcrumb: "Andere rechten",
      title: "Staat van het Vermogen",
      questionId: 82,
      subscriptionTypes: [1, 4],
    },
  },
  {
    path: StateOfAssetsPaths.Mortgages,
    loadComponent: () =>
      import(
        "./pages/staat-van-vermogen/state-of-assets-question/state-of-assets-question.component"
      ).then((c) => c.StateOfAssetsQuestionComponent),
    data: {
      breadcrumb: "Hypotheken",
      title: "Staat van het Vermogen",
      questionId: 83,
      subscriptionTypes: [1, 4],
    },
  },
  {
    path: StateOfAssetsPaths.Deposits,
    loadComponent: () =>
      import(
        "./pages/staat-van-vermogen/state-of-assets-question/state-of-assets-question.component"
      ).then((c) => c.StateOfAssetsQuestionComponent),
    data: {
      breadcrumb: "Gegeven waarborgen",
      title: "Staat van het Vermogen",
      questionId: 84,
      subscriptionTypes: [1, 4],
    },
  },
  {
    path: StateOfAssetsPaths.OtherCommitments,
    loadComponent: () =>
      import(
        "./pages/staat-van-vermogen/state-of-assets-question/state-of-assets-question.component"
      ).then((c) => c.StateOfAssetsQuestionComponent),
    data: {
      breadcrumb: "Andere verbintenissen",
      title: "Staat van het Vermogen",
      questionId: 85,
      subscriptionTypes: [1, 4],
    },
  },
] satisfies Route[];
